//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function loadSalesService(status, groupProducts, startDate, endDate, search, integrations, plataforms) {
    try {
        const response = await api.post(`/vendas`, {
            status: status,
            grupo: groupProducts,
            dataInicial: startDate,
            dataFinal: endDate,
            busca: search,
            integracoes: integrations,
            plataformas: plataforms
        });
        return response;
    } catch (err) {
        toast.error("Erro ao carregar vendas");
        return null;
    }
}